import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GroupIcon from "@material-ui/icons/Group";
import PersonIcon from "@material-ui/icons/Person";
import { AlternateEmail } from "@material-ui/icons";
import NewTicketModal from "../NewTicketModal";
import iconWhatsApp from "../../assets/icons/whatsapp.svg";
import iconWppBusiness from "../../assets/icons/wppbusiness.svg";
import iconTelegram from "../../assets/icons/telegram.svg";
import iconInstagram from "../../assets/icons/instagram.svg";
import iconFacebook from "../../assets/icons/facebook.svg";

const useStyles = makeStyles((theme) => ({
	contactAvatar: {
		width: 40,
		height: 40,
		minWidth: 40,
		minHeight: 40,
		borderRadius: "50%",
		backgroundColor: "#bdbdbd",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		overflow: "hidden",

		"& svg": {
			color: "#fff",
			fontSize: "2em",
		},
		"& img": {
			width: "100%",
			height: "100%",
			objectFit: "cover",
			display: "block",
		},
	},

	avatarWrap: {
		position: "relative",
		display: "inline-block",
	},

	channelIconOverlay: {
		position: "absolute",
		bottom: -4,
		right: -4,
		zIndex: 1,
		width: 22,
		height: 22,
		borderRadius: "50%",
		backgroundColor: "#fff",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden",
		boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
	},

	contactCard: {
		display: "flex",
		alignItems: "center",
		gap: "1rem",
		cursor: "pointer",
	},
}));

const ContactCard = ({ contact }) => {
	const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
	const [avatarImgError, setAvatarImgError] = useState(false);
	const classes = useStyles();

	useEffect(() => {
		setAvatarImgError(false);
	}, [contact?.id, contact?.profilePicUrl]);

	const showProfilePic = contact?.profilePicUrl && !avatarImgError;

	return (
		<>
			<NewTicketModal
				initialContact={contact}
				modalOpen={newTicketModalOpen}
				onClose={() => setNewTicketModalOpen(false)}
			/>
			<div
				className={classes.contactCard}
				onClick={() => {
					setNewTicketModalOpen(true);
				}}
			>
				<div className={classes.avatarWrap}>
					{showProfilePic ? (
						<div className={classes.contactAvatar}>
							<img
								src={contact.profilePicUrl}
								alt=""
								onError={() => setAvatarImgError(true)}
							/>
						</div>
					) : contact?.isGroup ? (
						<div className={classes.contactAvatar}>
							<GroupIcon />
						</div>
					) : (
						<div className={classes.contactAvatar}>
							<PersonIcon />
						</div>
					)}
					{(() => {
						const ch = (contact?.channel || "").toLowerCase().trim();
						if (ch === "email") {
							return (
								<div className={classes.channelIconOverlay} style={{ padding: 2 }}>
									<AlternateEmail fontSize="small" color="primary" />
								</div>
							);
						}
						let iconModule = null;
						if (ch === "whatsapp") iconModule = iconWhatsApp;
						else if (ch === "whatsappbusiness" || ch === "whatsapp_business_account" || ch === "whatsappcloud") iconModule = iconWppBusiness;
						else if (ch === "telegram") iconModule = iconTelegram;
						else if (ch === "instagram") iconModule = iconInstagram;
						else if (ch === "facebook") iconModule = iconFacebook;
						if (!iconModule) return null;
						const src = typeof iconModule === "string" ? iconModule : (iconModule && iconModule.default) || "";
						if (!src) return null;
						return (
							<div className={classes.channelIconOverlay}>
								<img
									src={src}
									alt=""
									style={{
										width: "100%",
										height: "100%",
										objectFit: "contain",
										display: "block",
									}}
								/>
							</div>
						);
					})()}
				</div>
				<div className="contact-card__name">{contact?.name}</div>
			</div>
		</>
	);
};

export default ContactCard;
